<idp-unsupported-browser-modal
  *ngIf="showModal"
  [content]="
    (facade.unsupportedBrowserPopup$ | ngrxPush) || emptyUnsupportedBrowserPopup
  "
  (dismissModal)="unSupportedBrowserClose()"
></idp-unsupported-browser-modal>
